import { FormControl } from '@angular/forms';
import { ICustomCta } from '@campaign-form/campaign-form.interface';
import { EDeliverableType } from '@enums/campaign.enum';
import { ICustomFile } from '@shared/components/file-uploader/file-uploader.interface';
import { IBase, IBaseDeliverableForm, IDeliverableBase } from '../deliverable-list.interface';

export interface IVisual extends IBase, ICustomCta {
  imageId: string | null;
  focus: EVisualFocus | null;
}

export interface IVisualDeliverable extends IDeliverableBase {
  type: EDeliverableType.visual;
  imageFile: ICustomFile | null;
  imageId: string | null;
  focus: EVisualFocus | null;
}

export interface IVisualDeliverableForm extends IBaseDeliverableForm {
  type: FormControl<EDeliverableType.visual>;
  imageFile: FormControl<ICustomFile | null>;
  imageId: FormControl<string | null>;
  focus: FormControl<EVisualFocus | null>;
}

export enum EVisualFocus {
  mixed = 'mixed',
  text = 'text',
  graphic = 'graphic',
}
